document.addEventListener('DOMContentLoaded', (event) => {
  const nameInput = document.querySelector('[name="contact[name]"]');
  const messageInput = document.querySelector('[name="contact[body]"]');
  const emailInput = document.querySelector('[name="contact[email]"]');
  const subjectInput = document.querySelector('[name="contact[email_subject]"]');
  const submitButton = document.querySelector('#submitButton');
  let subjectWasChosen = false;

  const email_error_message = document.querySelector('.email-error-message');
  const name_error_message = document.querySelector('.name-error-message');
  const message_error_message = document.querySelector('.message-error-message');
  const subject_error_message = document.querySelector('.subject-error-message');

  const nameRegex = /^[A-Za-z\s]+$/;
  const invalidCharsRegex = /[<>''"]/;
  const emailRegex = /^[^\s@<>''"]+@[^\s@]+\.[^\s@]+$/;

  nameInput.addEventListener('input', (event) => {
    const name = event.target.value.trim();
    if (name.length >= 3 && nameRegex.test(name) && !invalidCharsRegex.test(name)) {
      nameInput.classList.remove('incorrect-input');
      name_error_message.style.display = 'none';
    } else {
      nameInput.classList.add('incorrect-input');
      name_error_message.style.display = 'block';
    }
    validateForm();
  });

  messageInput.addEventListener('input', (event) => {
    const message = event.target.value.trim();
    if (message.length >= 10 && !invalidCharsRegex.test(message)) {
      messageInput.classList.remove('incorrect-input');
      message_error_message.style.display = 'none';
    } else {
      messageInput.classList.add('incorrect-input');
      message_error_message.style.display = 'block';
    }
    validateForm();
  });

  emailInput.addEventListener('input', (event) => {
    const email = event.target.value.trim();
    if (emailRegex.test(email)) {
      emailInput.classList.remove('incorrect-input');
      email_error_message.style.display = 'none';
    } else {
      emailInput.classList.add('incorrect-input');
      email_error_message.style.display = 'block';
    }
    validateForm();
  });

  subjectInput.addEventListener('input', (event) => {
    const subject = event.target.value;
    subjectWasChosen = true;
    if (subject !== 'placeholder') {
      subjectInput.classList.remove('incorrect-input');
      subject_error_message.style.display = 'none';
    } else {
      subjectInput.classList.add('incorrect-input');
      subject_error_message.style.display = 'block';
    }
    validateForm();
  });

  function validateForm() {
    const trimmedName = nameInput.value.trim();
    const trimmedMessage = messageInput.value.trim();
    const trimmedEmail = emailInput.value.trim();

    const isNameValid =
      trimmedName.length >= 3 && nameRegex.test(trimmedName) && !invalidCharsRegex.test(trimmedName);
    const isMessageValid = trimmedMessage.length >= 10 && !invalidCharsRegex.test(trimmedMessage);
    const isEmailValid = emailRegex.test(trimmedEmail);

    if (subjectWasChosen && isNameValid && isMessageValid && isEmailValid) {
      submitButton.disabled = false;
    } else {
      submitButton.disabled = true;
    }
  }

  validateForm();
});